<template>
  <div class="snippet snippet_m" :class="cssClass">
    <slot name="before"></slot>
    <router-link
      :to="documentRoute"
      class="snippet__body snippet__link"
      :target="openInNewWindow ? '_blank' : ''"
    >
      <span v-if="designation" class="snippet__designation">
        {{ designation }}
      </span>
      <span
        v-if="document.title"
        class="snippet__title"
        :title="document.title"
      >
        {{ document.title | truncateText(140) }}
      </span>
      <div class="snippet_m__info">
        <div
          class="snippet_m__base-icon"
          :style="dbIconStyle"
          :title="dbName"
        ></div>
        <div class="snippet__status">
          <svg width="20" height="20" class="snippet__status-icon">
            <use :xlink:href="statusIcon"></use>
          </svg>
          <div class="snippet__status-hint">{{ document.statusHint }}</div>
          <time
            v-if="document.statusDate"
            class="snippet__date snippet_m__date"
          >
            {{ document.statusDate | formatDate }}
          </time>
        </div>
      </div>
      <div v-if="label" class="snippet__label">
        {{ label | truncateText(140) }}
      </div>
    </router-link>
    <slot name="after"></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  DOCUMENT_FORMAT_HTML,
  DOCUMENT_FORMAT_SCAN
} from '@src/api/entities/ApiDocumentSearchCard';
import DocumentRoute from '@@/document/mixins/DocumentRoute';

export default {
  mixins: [DocumentRoute],

  props: {
    /** @type {Object|ApiDocumentBaseCardDef} */
    document: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: null
    },

    format: {
      type: String,
      default: null
    },

    target: {
      type: [String, Number],
      default: null
    },

    cssClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    openInNewWindow() {
      return this.$store.getters.getOpenInWindow;
    },
    ...mapState(['databases', 'documentStatuses']),

    /** @returns {ApiDatabase|undefined} */
    database() {
      return this.databases[this.document.dbId];
    },

    dbName() {
      return this.database ? this.database.name : '';
    },

    dbIconStyle() {
      return this.database
        ? { backgroundImage: `url('${this.database.iconUrl}')` }
        : '';
    },

    designation() {
      if (this.document.designation) return this.document.designation;

      let type = this.document.type,
        number = this.document.number;

      return type + (type && number ? ' ' : '') + number;
    },

    statusIcon() {
      return this.documentStatuses[this.document.statusId].icon;
    },

    documentRoute() {
      if (this.format === DOCUMENT_FORMAT_HTML) {
        return this.makeDocumentHtmlRoute(this.document.id, this.target);
      } else if (this.format === DOCUMENT_FORMAT_SCAN) {
        return this.makeDocumentScanRoute(this.document.id, this.target);
      }
      return this.makeDocumentRoute(this.document.id);
    }
  }
};
</script>
